import Api from '@/services/api/plataformas/api/index.js';
import endpoints from './endpoint';

/**
 * The caller's own entitlements decide what comes back, `calendario_id` narrows it and
 * answers 403 when the student is not enrolled in that calendar.
 *
 * Explicit `take`: the contract defaults to 50 truncating the average resultset, 2000 is the cap.
 */
const list = (args) => {
  const params = new URLSearchParams();

  params.append('calendario_id', args.calendario_id);
  params.append('take', '2000');

  return Api.get(`${endpoints.get('list')}?${params.toString()}`);
};

export default {
  list,
};
